import React from 'react';

import CSSModules from 'react-css-modules';

import {LinkIcon} from '../../../icons';
import type {BaseObject} from '../../types';

import styles from '../styles.module.scss';

interface LinkObjectProps<T extends BaseObject> {
  object: Extract<T, {type: 'stepLink'}>;
  setSelectedObject: (object: T) => void;
}

const LinkObjectComponent = <T extends BaseObject>({
  object,
  setSelectedObject,
}: LinkObjectProps<T>) => (
  <div
    styleName='step-link'
    onClick={() => {
      setSelectedObject(object);
    }}
  >
    <div styleName='text'>
      <span>
        <LinkIcon />
      </span>
      {object.text || object?.url}
    </div>
  </div>
);

export const LinkObject = CSSModules(LinkObjectComponent, styles);
